:root {
  color-scheme: light;
  font-family:
    Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #141713;
  background: #f6f7f2;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  --ink: #141713;
  --muted: #667064;
  --paper: #ffffff;
  --wash: #f6f7f2;
  --line: #dfe4dc;
  --green: #14795a;
  --green-bg: #e3f2eb;
  --red: #b33f39;
  --red-bg: #f8e3df;
  --blue: #2459a8;
  --gold: #9f6a16;
  --shadow: 0 18px 42px rgba(20, 23, 19, 0.07);
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  min-width: 320px;
  background: var(--wash);
}

button,
input {
  font: inherit;
}

button {
  cursor: pointer;
}

a {
  color: inherit;
  text-decoration: none;
}

.topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 58px;
  padding: 0 max(18px, calc((100vw - 1180px) / 2));
  border-bottom: 1px solid rgba(223, 228, 220, 0.92);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(14px);
}

.brand,
.topbar-meta,
.eyebrow,
.source-note,
.source-link,
.chip-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.brand {
  font-size: 18px;
  font-weight: 900;
}

.brand svg {
  color: var(--green);
}

.topbar-meta {
  color: var(--muted);
  font-size: 13px;
}

.hero,
.toolbar,
.watch-panel,
.fund-flow-section,
.profiles-section,
.sources {
  width: min(1180px, calc(100% - 40px));
  margin: 0 auto;
}

.hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 22px;
  padding: 34px 0 24px;
  align-items: stretch;
}

.hero-main,
.hero-side,
.watch-panel,
.profile-card,
.sources {
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--paper);
  box-shadow: var(--shadow);
}

.hero-main {
  min-width: 0;
  padding: 26px;
}

.eyebrow,
.section-kicker {
  color: var(--blue);
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: uppercase;
}

.hero h1 {
  max-width: 760px;
  margin: 12px 0 18px;
  font-size: clamp(36px, 6vw, 68px);
  line-height: 1;
  letter-spacing: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.market-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  max-width: 360px;
  margin: 0 0 18px;
}

.market-tabs button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 44px;
  padding: 0 12px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #f7f9f5;
  color: var(--ink);
  font-weight: 850;
}

.market-tabs button b {
  color: var(--muted);
  font-size: 12px;
}

.market-tabs button.active {
  border-color: var(--ink);
  background: var(--ink);
  color: #fff;
}

.market-tabs button.active b {
  color: #dfe6dd;
}

.name-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.name-pill,
.tier,
.profile-tags span {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0 9px;
  border-radius: 999px;
  background: #eef2ec;
  color: #465047;
  font-size: 12px;
  font-weight: 800;
}

.name-pill {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 150px;
  min-height: 46px;
  padding: 7px 11px;
  gap: 3px;
  border-radius: 10px;
}

.name-pill b,
.name-pill small {
  line-height: 1.15;
  white-space: nowrap;
}

.name-pill small {
  color: var(--muted);
  font-size: 11px;
  font-weight: 850;
}

.hero-pulse {
  display: grid;
  grid-template-columns: 178px minmax(0, 1fr);
  gap: 14px;
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid var(--line);
}

.pulse-score {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

.pulse-score span {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  min-height: 34px;
  padding: 0 10px;
  border-radius: 7px;
  background: #f2f5f0;
  color: var(--muted);
  font-size: 13px;
  font-weight: 850;
}

.pulse-score span:first-child svg,
.pulse-feed .positive {
  color: var(--green);
}

.pulse-score span:last-child svg,
.pulse-feed .negative {
  color: var(--red);
}

.pulse-feed {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  min-width: 0;
}

.pulse-feed a,
.pulse-empty {
  min-width: 0;
  min-height: 76px;
  padding: 10px;
  border-radius: 7px;
  background: #f7f9f5;
}

.pulse-feed a {
  display: grid;
  align-content: space-between;
  gap: 5px;
}

.pulse-feed b,
.pulse-feed small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pulse-feed b {
  font-size: 17px;
}

.pulse-feed span,
.pulse-feed small,
.pulse-empty {
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
}

.pulse-empty {
  display: flex;
  align-items: center;
  grid-column: 1 / -1;
}

.hero-side {
  display: grid;
  gap: 10px;
  padding: 18px;
}

.metric {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 72px;
  padding: 14px;
  border-radius: 8px;
  background: #f7f9f5;
}

.metric span {
  color: var(--muted);
  font-size: 13px;
  font-weight: 750;
}

.metric strong {
  font-size: 30px;
  line-height: 1;
}

.toolbar,
.section-title-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  margin-top: 18px;
  margin-bottom: 12px;
}

.toolbar h2,
.section-title-row h2,
.source-copy h2 {
  margin: 4px 0 0;
  font-size: clamp(24px, 4vw, 38px);
  line-height: 1.08;
  letter-spacing: 0;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  width: min(300px, 100%);
  min-height: 40px;
  padding: 0 12px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--paper);
}

.search-box svg {
  color: var(--muted);
  flex: 0 0 auto;
}

.search-box input {
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
}

.watch-panel {
  padding: 10px;
}

.fund-flow-section {
  padding-top: 10px;
}

.section-title-row.compact {
  margin-top: 20px;
}

.source-anchor {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 850;
}

.fund-flow-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 10px;
}

.fund-flow-card {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 8px 10px;
  min-width: 0;
  min-height: 118px;
  padding: 13px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--paper);
  box-shadow: var(--shadow);
}

.fund-flow-card:hover {
  background: #fbfcfa;
}

.fund-rank {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: var(--ink);
  color: #fff;
  font-size: 13px;
  font-weight: 900;
}

.fund-security {
  min-width: 0;
}

.fund-security strong,
.fund-security span {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fund-security strong {
  font-size: 17px;
  line-height: 1.05;
}

.fund-security span {
  margin-top: 3px;
  color: var(--muted);
  font-size: 12px;
  font-weight: 850;
}

.fund-flow-card b,
.fund-flow-card small {
  grid-column: 1 / -1;
}

.fund-flow-card b {
  color: var(--green);
  font-size: 21px;
  line-height: 1;
}

.fund-flow-card small {
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
}

.move-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 10px;
}

.recent-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 206px;
  padding: 16px;
  border-radius: 8px;
  background: #fbfcfa;
}

.recent-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.recent-head h3 {
  margin: 0;
  font-size: 22px;
  line-height: 1.15;
}

.recent-head p {
  margin: 4px 0 0;
  color: var(--muted);
  font-size: 13px;
  font-weight: 800;
}

.recent-head a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 7px;
  background: #eef2ec;
  color: var(--muted);
  flex: 0 0 auto;
}

.recent-move-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: auto;
}

.recent-move-columns.single {
  grid-template-columns: 1fr;
}

.recent-move-list {
  min-width: 0;
}

.recent-move-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 7px;
  color: var(--muted);
  font-size: 13px;
  font-weight: 900;
}

.recent-move-list.positive .recent-move-title svg {
  color: var(--green);
}

.recent-move-list.negative .recent-move-title svg {
  color: var(--red);
}

.recent-move-list div {
  display: grid;
  gap: 6px;
}

.recent-move-list a,
.recent-empty {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
  min-height: 31px;
  padding: 0 9px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 900;
}

.recent-move-list.positive a {
  background: var(--green-bg);
}

.recent-move-list.negative a {
  background: var(--red-bg);
}

.recent-move-list a span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-move-list a small {
  color: var(--muted);
  flex: 0 0 auto;
  font-weight: 850;
}

.recent-empty {
  justify-content: center;
  background: #eef2ec;
  color: var(--muted);
}

.move-card {
  display: grid;
  align-content: space-between;
  gap: 10px;
  min-width: 0;
  min-height: 118px;
  padding: 12px;
  border-radius: 7px;
  background: #fbfcfa;
}

.move-card:hover {
  background: #f5f7f2;
}

.move-card-head,
.move-card-foot,
.summary-counts {
  display: flex;
  align-items: center;
  gap: 8px;
}

.move-card-head {
  justify-content: space-between;
}

.move-card-head strong {
  min-width: 0;
  flex: 1 1 auto;
  font-size: 17px;
  line-height: 1.18;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.move-card-head svg {
  color: var(--muted);
  flex: 0 0 auto;
}

.move-card-body {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.move-card-body span,
.move-card-body small {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.move-card-body span {
  font-weight: 850;
}

.move-card-body small,
.move-card-foot,
.summary-counts,
.summary-items {
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
}

.move-card-foot {
  justify-content: space-between;
}

.move-card-foot b {
  color: var(--ink);
  font-size: 14px;
}

.move-card.summary {
  background: #f2f5f0;
}

.summary-counts {
  justify-content: flex-start;
}

.summary-counts span,
.summary-counts b {
  min-height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--paper);
}

.summary-items {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px;
}

.summary-items span {
  min-width: 0;
  padding: 5px 7px;
  border-radius: 7px;
  background: var(--paper);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary-items .positive {
  color: var(--green);
}

.summary-items .negative {
  color: var(--red);
}

.move-row {
  display: grid;
  grid-template-columns: 34px minmax(70px, 0.72fr) minmax(120px, 1.4fr) minmax(92px, 0.7fr) 64px 18px;
  gap: 10px;
  align-items: center;
  min-height: 48px;
  padding: 6px 10px;
  border-radius: 7px;
}

.move-row:hover {
  background: #f5f7f2;
}

.direction-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 900;
}

.direction-badge.positive,
.positive-text {
  color: var(--green);
}

.direction-badge.positive {
  background: var(--green-bg);
}

.direction-badge.negative,
.negative-text {
  color: var(--red);
}

.direction-badge.negative {
  background: var(--red-bg);
}

.move-row strong {
  font-size: 16px;
  overflow-wrap: anywhere;
}

.move-person {
  min-width: 0;
  color: var(--ink);
  font-weight: 750;
}

.move-person small {
  display: block;
  margin-top: 2px;
  color: var(--muted);
  font-size: 12px;
  font-weight: 650;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.move-mobile-meta {
  display: none;
}

.move-value,
.move-date,
.freshness {
  color: var(--muted);
  font-size: 13px;
  font-weight: 750;
}

.move-value {
  color: var(--ink);
  text-align: right;
}

.move-row svg {
  color: var(--muted);
}

.profiles-section {
  padding: 28px 0 44px;
}

.profile-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.profile-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 286px;
  padding: 16px;
}

.profile-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.profile-card h3 {
  margin: 0;
  font-size: 19px;
  line-height: 1.18;
}

.profile-card p {
  margin: 5px 0 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.35;
}

.tier {
  flex: 0 0 auto;
  background: #eef3f7;
  color: var(--blue);
}

.profile-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin: 12px 0 10px;
}

.profile-scan {
  display: grid;
  gap: 10px;
}

.return-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.return-row div {
  min-height: 54px;
  padding: 10px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #fbfcfa;
}

.return-row span,
.return-source {
  display: block;
  color: var(--muted);
  font-size: 12px;
}

.return-row strong {
  display: block;
  margin-top: 5px;
  font-size: 19px;
}

.return-source {
  min-height: 18px;
  margin: 8px 0 0;
  line-height: 1.35;
}

.move-stack {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(132px, 1fr));
  gap: 8px;
}

.holding-chips,
.holding-empty {
  min-width: 0;
  padding: 9px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #fbfcfa;
}

.holding-title {
  display: block;
  margin-bottom: 6px;
  color: var(--muted);
  font-size: 12px;
  font-weight: 850;
}

.holding-chips div {
  display: grid;
  gap: 5px;
}

.holding-chips a,
.holding-chips div > span {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 27px;
  gap: 8px;
  padding: 0 8px;
  border-radius: 7px;
  background: #eef2ec;
  font-size: 12px;
  font-weight: 900;
}

.holding-chips a span,
.holding-chips div > span span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.holding-chips small {
  flex: 0 0 auto;
  color: var(--blue);
  font-weight: 900;
}

.holding-empty {
  color: var(--muted);
  font-size: 12px;
  font-weight: 850;
}

.move-chips {
  min-width: 0;
}

.chip-title {
  margin-bottom: 6px;
  color: var(--muted);
  font-size: 12px;
  font-weight: 850;
}

.move-chips.positive .chip-title svg {
  color: var(--green);
}

.move-chips.negative .chip-title svg {
  color: var(--red);
}

.move-chips div {
  display: grid;
  gap: 5px;
}

.move-chips a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
  min-height: 27px;
  padding: 0 8px;
  border-radius: 7px;
  background: #f2f5f0;
  font-size: 12px;
  font-weight: 850;
}

.move-chips.positive a {
  background: var(--green-bg);
}

.move-chips.negative a {
  background: var(--red-bg);
}

.move-chips a span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.move-chips small {
  color: var(--muted);
  flex: 0 0 auto;
  font-weight: 750;
}

.pending-note,
.empty-state {
  color: var(--muted);
  font-size: 13px;
  line-height: 1.5;
}

.pending-note {
  margin-top: auto;
  padding-top: 14px;
}

.empty-state {
  min-height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
}

.sources {
  display: grid;
  grid-template-columns: minmax(0, 0.78fr) minmax(320px, 1fr);
  gap: 28px;
  margin-bottom: 44px;
  padding: 22px;
  background: #18201b;
  color: #f8fbf7;
}

.source-copy p {
  color: #d6dfd4;
  line-height: 1.7;
}

.source-list {
  display: grid;
  gap: 8px;
}

.source-note,
.source-link {
  min-height: 42px;
  padding: 10px 12px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.07);
  color: #eef6ec;
  font-size: 13px;
  line-height: 1.45;
}

.source-note svg {
  flex: 0 0 auto;
  color: #78d9ac;
}

.source-link {
  justify-content: space-between;
  font-weight: 800;
}

.source-link svg {
  color: #aee4cb;
}

.loading-shell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 100vh;
  color: var(--muted);
  font-weight: 850;
}

.loading-shell.error {
  color: var(--red);
}

.spin {
  animation: spin 1.1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 980px) {
  .hero {
    grid-template-columns: 1fr;
  }

  .hero-side {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .profile-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sources {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 720px) {
  .hero,
  .toolbar,
  .watch-panel,
  .fund-flow-section,
  .profiles-section,
  .sources {
    width: min(100% - 28px, 1180px);
  }

  .topbar {
    padding: 0 14px;
  }

  .topbar-meta {
    display: none;
  }

  .hero {
    padding-top: 20px;
  }

  .hero-main {
    padding: 18px;
  }

  .hero h1 {
    max-width: 100%;
    font-size: 34px;
  }

  .market-tabs {
    max-width: none;
  }

  .name-strip {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 4px;
    scrollbar-width: none;
  }

  .name-strip::-webkit-scrollbar {
    display: none;
  }

  .name-pill {
    flex: 0 0 auto;
  }

  .hero-pulse {
    grid-template-columns: 1fr;
  }

  .pulse-score,
  .pulse-feed {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .pulse-feed a,
  .pulse-empty {
    min-height: 62px;
  }

  .hero-side,
  .profile-grid {
    grid-template-columns: 1fr;
  }

  .toolbar,
  .section-title-row {
    align-items: stretch;
    flex-direction: column;
  }

  .search-box {
    width: 100%;
  }

  .move-row {
    grid-template-columns: 32px minmax(56px, 0.52fr) minmax(112px, 1fr) 18px;
    min-height: 54px;
  }

  .move-source {
    display: none !important;
  }

  .move-mobile-meta {
    display: block;
  }

  .move-value,
  .move-date {
    display: none;
  }

  .move-stack {
    grid-template-columns: 1fr;
  }

  .profile-card {
    min-height: auto;
  }
}
